import { createSlice } from "@reduxjs/toolkit"

const initialData = {
   loading:false,
   revenuereport:[],
   patientreport:[],
   customerreport:[], // Keep for backward compatibility
   appointmentreport:[],
}

const reportReducer = createSlice({
    name:'reports',
    initialState:initialData,
    reducers:{
        loadingReports(state){
            state.loading=true;
            state.appointmentreport=[];
            state.patientreport=[]
            state.customerreport=[] // Keep for backward compatibility
            state.revenuereport=[]
        },
        loadingAppointmentReports(state,action){
            state.loading=false;
            state.appointmentreport=action.payload;
        },
        loadingRevenueReports(state,action){
            state.loading=false;
            state.revenuereport=action.payload;
        },
        loadingPaitientsReports(state,action){
            state.loading=false;
            state.patientreport=action.payload;
            state.customerreport=action.payload; // Keep for backward compatibility
        },
    }
});

export default reportReducer.reducer;

export const {loadingReports,loadingAppointmentReports,loadingPaitientsReports,loadingRevenueReports} = reportReducer.actions;